let disclosuresModalLoaded = false;
const $disclosuresModal = $('#disclosures-modal');
const $disclosureSuperscripts = $('.disclosure-superscript');

// Make disclosure superscripts open modal on keyboard spacebar and enter
$disclosureSuperscripts.keydown(function (e) {
  switch (e.key) {
    case 'Enter':
    case 'Spacebar':
    case ' ':
      e.preventDefault();
      $(this).click();
      break;
    default:
      return;
  }
});

// On shown modal event
$disclosuresModal.on('shown.bs.modal', function (e) {
  const disclosureId = $(e.relatedTarget).data('disclosure');

  if (!disclosuresModalLoaded) {
    loadDisclosuresModal(disclosureId);
    disclosuresModalLoaded = true;
  } else {
    focusOnDisclosure(disclosureId);
  }
})

// Loads the disclosures modal content, and then focuses on the disclosure with the specified ID
function loadDisclosuresModal(disclosureId) {
  var lang = document.documentElement.lang;

  $.getJSON(`/api/disclosuresdata/${lang}`, function (data) {

    var items = [];
    $.each(data.disclosures, function (i, item) {
      items.push('<li id="disclosure-' + item.disclosureNumber + '" class="disclosure" tabindex="0"><strong class="disclosure-number">' + item.disclosureNumber + ':</strong> <div class="disclosure-text">' + item.disclosureText + '</div></li>');
    });

    $disclosuresModal.find('.modal-body').html($('<ul/>', {
      'class': 'list-unstyled',
      'id': 'disclosures-list',
      html: items.join('')
    }));

    focusOnDisclosure(disclosureId)

  });
}

// Focus on the disclosure with the specified ID
function focusOnDisclosure(disclosureId) {
  if (disclosureId) {
    let $disclosure = $(disclosureId);

    $disclosure.focus();
    $disclosuresModal.animate({
      scrollTop: $disclosure.position().top
    }, 500);
  }
}
